<template>
  <div :class="classesInput">
    <select class="dropdown"
      :value="internalValue"
      v-bind="$attrs"
      v-on="{
        ...$listeners,
        input: event => $emit('input', event.target.value)
      }"
    >
      <option v-if="!!label" :selected="!internalValue" :value="null">{{label}}</option>
      <option
        v-for="item in items"
        :key="item[itemValue]"
        :value="item[itemValue]"
        :selected="item[itemValue] === internalValue"
      >{{item[itemText]}}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'AppFormDropdown',
  status: 'prototype',
  release: '1.0.0',
  inheritAttrs: false,
  props: {
    value: {
      required: true
    },
    label: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      default: []
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemText: {
      type: String,
      default: 'text'
    }
  },
  data () {
    return {
      lazyValue: this.value,
      dropdownIsOpen: false
    }
  },
  computed: {
    classesInput () {
      return {
        'input-wrapper': true,
        'input--is-label-active': this.isLabelActive,
        'input--is-dirty': this.isDirty,
        'input--is-disabled': this.disabled,
        'input--is-readonly': this.readonly
      }
    },
    classesDropdown () {
      return {
        'dropdown': 'dropdown',
        'open': this.dropdownIsOpen
      }
    },
    internalValue: {
      get () {
        return this.lazyValue
      },
      set (val) {
        this.lazyValue = val
        this.$emit('input', val)
      }
    },
    isDirty () {
      return !!this.lazyValue
    },
    isDisabled () {
      return !!this.disabled || !!this.readonly
    },
    isLabelActive () {
      return this.isDirty
    }
  },
  watch: {
    value (val) {
      this.lazyValue = val
    }
  },
  methods: {
    toggleDropdown () {
      this.dropdownIsOpen = !this.dropdownIsOpen
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/styles.scss";
.input-wrapper {
  position: relative;
  &:after {
    position: absolute;
    display: block;
    content: "";
    width: 6px;
    height: 6px;
    right: 20px;
    top: 50%;
    transform: translateY(-50%) rotate(-45deg);
    border: 2px solid rgb(0, 170, 167);
    border-top: 0;
    border-right: 0;
  }
  .dropdown {
    width: 100%;
    height: 61px;
    padding: 18px 20px;
    box-sizing: border-box;
    border-radius: 10px;
    border: solid 1px $color-gray-light;
    background-color: $color-white;
    -webkit-appearance: none;
    position: relative;
    text-align: left;
    font-family: $font-text;
    font-size: $size-m;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.22;
    letter-spacing: normal;
    outline: none;
    color: $color-purple-darker;
  }
}
</style>
